/* ============================================================
   KK Custom Header – Interaktion
   Mega-Menu (Hover + Tastatur), Mobile-Drawer, Accordion,
   Hover-Preview-Wechsel, A11y (aria, Escape, Focus-Trap), Sticky.
   Kein externes Framework. Minimal & defensiv.
   ============================================================ */
(function(){
  'use strict';
  var root = document.querySelector('[data-kk-header]');
  if(!root) return;

  /* ---------- Sticky shadow ---------- */
  var bar = root.querySelector('.kk-header');
  if(bar){
    var onScroll = function(){ bar.classList.toggle('is-stuck', window.scrollY > 6); };
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ---------- Desktop Mega Menu ---------- */
  var tops = Array.prototype.slice.call(root.querySelectorAll('.kk-nav__top[data-has-mega]'));
  var closeTimer = null;
  var mqDesktop = window.matchMedia('(min-width:991px)');

  function openMega(li){
    if(!mqDesktop.matches) return;
    clearTimeout(closeTimer);
    closeAllMega(li);
    var btn = li.querySelector('button');
    var mega = li.querySelector('.kk-mega');
    if(!mega) return;
    li.classList.add('is-open');
    mega.classList.add('is-open');
    if(btn) btn.setAttribute('aria-expanded','true');
  }
  function closeMega(li){
    var btn = li.querySelector('button');
    var mega = li.querySelector('.kk-mega');
    li.classList.remove('is-open');
    if(mega) mega.classList.remove('is-open');
    if(btn) btn.setAttribute('aria-expanded','false');
  }
  function closeAllMega(except){
    tops.forEach(function(li){ if(li!==except) closeMega(li); });
  }

  tops.forEach(function(li){
    var btn = li.querySelector('button');
    li.addEventListener('mouseenter', function(){ openMega(li); });
    li.addEventListener('mouseleave', function(){
      closeTimer = setTimeout(function(){ closeMega(li); }, 140);
    });
    if(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if(li.classList.contains('is-open')){ closeMega(li); }
        else{ openMega(li); }
      });
      btn.addEventListener('keydown', function(e){
        if(e.key==='Escape'){ closeMega(li); btn.focus(); }
      });
    }
    /* ----- Hover-Preview-Wechsel (Wow-Effekt, kein CLS) ----- */
    var cards = Array.prototype.slice.call(li.querySelectorAll('.kk-preview-card'));
    var triggers = Array.prototype.slice.call(li.querySelectorAll('[data-preview]'));
    if(cards.length && triggers.length){
      var activate = function(key){
        var hasMatch = cards.some(function(c){ return c.getAttribute('data-preview-card')===key; });
        var target = hasMatch ? key : 'default';
        cards.forEach(function(c){ c.classList.toggle('is-active', c.getAttribute('data-preview-card')===target); });
      };
      triggers.forEach(function(t){
        var key = t.getAttribute('data-preview');
        t.addEventListener('mouseenter', function(){ activate(key); });
        t.addEventListener('focus', function(){ activate(key); });
      });
    }
  });

  document.addEventListener('keydown', function(e){
    if(e.key==='Escape') closeAllMega(null);
  });
  document.addEventListener('click', function(e){
    if(!root.contains(e.target)) closeAllMega(null);
  });

  /* ---------- Mobile Drawer ---------- */
  var burger = root.querySelector('[data-kk-burger]');
  var drawer = root.querySelector('[data-kk-drawer]');
  var lastFocus = null;

  function focusables(scope){
    return Array.prototype.slice.call(scope.querySelectorAll(
      'a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])'
    )).filter(function(el){ return el.offsetParent !== null; });
  }
  function openDrawer(){
    if(!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('hidden');
    document.documentElement.style.overflow='hidden';
    if(burger) burger.setAttribute('aria-expanded','true');
    var f = focusables(drawer); if(f.length) f[0].focus();
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow='';
    if(burger) burger.setAttribute('aria-expanded','false');
    if(lastFocus) lastFocus.focus();
    setTimeout(function(){ if(!drawer.classList.contains('is-open')) drawer.setAttribute('hidden',''); },350);
  }
  if(burger) burger.addEventListener('click', openDrawer);
  if(drawer){
    drawer.addEventListener('click', function(e){
      if(e.target.hasAttribute('data-kk-drawer-close') || e.target.closest('[data-kk-drawer-close]')) closeDrawer();
    });
    drawer.addEventListener('keydown', function(e){
      if(e.key==='Escape'){ closeDrawer(); return; }
      if(e.key==='Tab'){
        var f = focusables(drawer); if(!f.length) return;
        var first=f[0], last=f[f.length-1];
        if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- Mobile Accordion ---------- */
  var accs = Array.prototype.slice.call(root.querySelectorAll('.kk-acc'));
  accs.forEach(function(acc){
    var top = acc.querySelector('[data-acc-toggle]') || acc.querySelector('.kk-acc__top');
    var panel = acc.querySelector('.kk-acc__panel');
    if(!top||!panel) return;
    top.addEventListener('click', function(){
      var open = acc.classList.toggle('is-open');
      top.setAttribute('aria-expanded', open ? 'true':'false');
      panel.style.maxHeight = open ? (panel.scrollHeight+'px') : '0px';
    });
  });

  /* ---------- Live cart count ---------- */
  var countEl = root.querySelector('[data-kk-cart-count]');
  function refreshCart(){
    if(!countEl) return;
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){
        if(!c) return;
        var n = c.item_count||0;
        countEl.textContent = n;
        if(n>0){ countEl.removeAttribute('hidden'); } else { countEl.setAttribute('hidden',''); }
      }).catch(function(){});
  }
  refreshCart();
  document.addEventListener('cart:updated', refreshCart);
  document.addEventListener('ajaxCart.afterCartLoad', refreshCart);
})();
